import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalUnifiedEventStepContent(props) {
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "approval-unified-event-content",
    className: "m-left-4 p-top-1",
    style: {
      textTransform: 'none',
      fontSize: '14px',
      fontWeight: 400,
      overflowWrap: 'anywhere',
      hyphens: 'auto'
    },
    children: props.children
  });
}